// extracted by css-extract-rspack-plugin
export default {"ivideonLogsPage":"D7PY6xTwHA1gbrZM","tableWrapper":"gdRuIWRXUowldAnB","buttonsBlock":"NLLEuceDEvM1XiwP"};